import * as React from 'react';
import { ExpressionScope, FormProvider, FormConsumer, } from '@formily/react';
import { createForm } from '@formily/core';
import { SchemaField } from '@/form/schema-field';
import { CnFormLayout } from '@/form/cn-form-layout';
import { CnSubmit } from '@/form/cn-submit';
import { CnReset } from '@/form/cn-reset';
import { CnButtonGroup } from '@/components/cn-button-group';
import { CnPageFooter } from '@/components/cn-page-footer';
export const CnForm = (props) => {
    const { formProps, components, schema, formLayoutProps, form, children, hasFooterSubmit, footerConfig, onSubmit, onReset, } = props;
    const formInstance = React.useMemo(() => {
        if (form) {
            return form;
        }
        return createForm(formProps);
    }, [form, schema]);
    const footer = React.useMemo(() => {
        if (!hasFooterSubmit && !footerConfig)
            return;
        const { submitProps, resetProps, className, customRender, ...otherProps } = footerConfig || {};
        if (customRender) {
            return (React.createElement(CnPageFooter, { className: className, rightSlot: React.createElement(FormConsumer, null, customRender), ...otherProps }));
        }
        return (React.createElement(CnPageFooter, { className: className, ...otherProps },
            React.createElement(CnButtonGroup, { fullWidth: true, size: "large" },
                React.createElement(CnReset, { ...resetProps, form: formInstance, onReset: onReset }),
                React.createElement(CnSubmit, { size: "large", ...submitProps, form: formInstance, onSubmit: onSubmit }))));
    }, [footerConfig, formInstance, hasFooterSubmit, onReset, onSubmit]);
    return (React.createElement(FormProvider, { form: formInstance },
        React.createElement(ExpressionScope, { value: { $$form: formInstance } },
            React.createElement(CnFormLayout, { ...formLayoutProps },
                React.createElement(SchemaField, { schema: schema, components: components }),
                children)),
        footer));
};
CnForm.displayName = 'CnForm';
